import React from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import get from 'lodash/get';
import { string } from 'prop-types';

const TruncatedTextField = props => {
    const classes = useStyles();
    const value = get(props.record, props.source);

    return (
        <Tooltip title={value || ''}>
            <TextField className={classes.root} value={value} {...props} />
        </Tooltip>
    );
};

const useStyles = makeStyles(
    theme => ({
        root: {
            display: 'inline-block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '15vw',
            [theme.breakpoints.up('lg')]: {
                maxWidth: '10vw',
            },
        },
    }),
);

TruncatedTextField.propTypes = {
    record: string,
    source: string,
};

export default TruncatedTextField;